import { apiFetchJson } from "./apiClient";
import {
  AssetTableItem,
  AssetSection,
  AssetDiceTemplate,
  AssetDiceTemplateRequest,
} from "../types/types";

export interface UpdateAssetRequest {
  name: string;
  type: string;
  category: string;
  description: string;
  dmNotes?: string; // Private DM-only notes, never shared
}

export interface CreateAssetSectionRequest {
  name: string;
  description: string;
  dmNotes?: string; // Private DM-only notes, never shared
}

export interface UpdateAssetSectionRequest {
  name: string;
  description: string;
  dmNotes?: string; // Private DM-only notes, never shared
}

export class AssetService {
  // Get asset details
  static async getAssetDetails(assetId: number): Promise<AssetTableItem> {
    return apiFetchJson(`/api/protected/assets/${assetId}`);
  }

  // Update asset
  static async updateAsset(assetId: number, request: UpdateAssetRequest): Promise<AssetTableItem> {
    return apiFetchJson(`/api/protected/assets/${assetId}`, {
      method: "PUT",
      body: JSON.stringify(request),
    });
  }

  // Get asset sections
  static async getAssetSections(assetId: number): Promise<AssetSection[]> {
    return apiFetchJson(`/api/protected/assets/${assetId}/section`);
  }

  // Create asset section
  static async createAssetSection(
    assetId: number,
    request: CreateAssetSectionRequest
  ): Promise<AssetSection> {
    return apiFetchJson(`/api/protected/assets/${assetId}/section`, {
      method: "POST",
      body: JSON.stringify(request),
    });
  }

  // Update asset section
  static async updateAssetSection(
    assetId: number,
    sectionId: number,
    request: UpdateAssetSectionRequest
  ): Promise<AssetSection> {
    return apiFetchJson(`/api/protected/assets/${assetId}/section/${sectionId}`, {
      method: "PUT",
      body: JSON.stringify(request),
    });
  }

  // Delete asset section
  static async deleteAssetSection(
    assetId: number,
    sectionId: number
  ): Promise<{ message: string }> {
    return apiFetchJson(`/api/protected/assets/${assetId}/section/${sectionId}`, {
      method: "DELETE",
    });
  }

  // ── Fate Formulas (Dice Templates) for Beast / NPC entries ───────────────

  static async getAssetDiceTemplates(assetId: number): Promise<AssetDiceTemplate[]> {
    return apiFetchJson(`/api/protected/assets/asset/${assetId}/dice-templates`);
  }

  static async createAssetDiceTemplate(
    assetId: number,
    request: AssetDiceTemplateRequest
  ): Promise<AssetDiceTemplate> {
    return apiFetchJson(`/api/protected/assets/asset/${assetId}/dice-templates`, {
      method: "POST",
      body: JSON.stringify(request),
    });
  }

  static async updateAssetDiceTemplate(
    assetId: number,
    templateId: number,
    request: AssetDiceTemplateRequest
  ): Promise<AssetDiceTemplate> {
    return apiFetchJson(`/api/protected/assets/asset/${assetId}/dice-templates/${templateId}`, {
      method: "PUT",
      body: JSON.stringify(request),
    });
  }

  static async deleteAssetDiceTemplate(assetId: number, templateId: number): Promise<void> {
    return apiFetchJson(`/api/protected/assets/asset/${assetId}/dice-templates/${templateId}`, {
      method: "DELETE",
    });
  }
}
